/* eslint-disable @typescript-eslint/naming-convention */
import _refiner from 'refiner-js';
import { REFINER_TOKEN } from '@/constants/Config';

_refiner('setProject', REFINER_TOKEN);

type RefinerEvent = 'HQ Visited';

const RefinerUtils = {
  /* Identify a user by email */
  identify: (email: string): void => {
    _refiner('identifyUser', { id: email, email });
  },

  /* Track an event in Refiner */
  track: (event: RefinerEvent): void => {
    _refiner('trackEvent', event);
  },

  /* Reset user session in Refiner */
  reset: (): void => {
    _refiner('resetUser');
    _refiner('stopPinging');
  },
};

export default RefinerUtils;
